

import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import tmdbApi from "../../api/tmdbApi";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import InsideHeader from "../../components/InnerHeader/Header";
import SessionPopup from "../SessionPopup";
import axios from "axios";
import moment from "moment";
import { contentContext } from "../../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ReactHtmlParser from 'react-html-parser';
import InactivePopup from "../inactivePopup";
import { Navigate } from "react-router-dom";
let { lambda, appname } = window.app;


const Faq = () => {
    const navigate = useNavigate();
    const [config, setConfig] = useState({});
    const [emailError, setEmailError] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [nameerror, setNameError] = useState('');
    const [subject, setSubject] = useState('');
    const [msg, setMsg] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [suberror, setSubError] = useState('');
    const [success, setSuccess] = useState('');
    const [teamBoard, setTeamBoard] = useState([]);
    const [teamMember, setTeamMember] = useState({});
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [activeCheckId, setActiveCheckId] = useState("");
    const [showDescription, setShowDescription] = useState(false);
    const [sec1, setSec1] = useState({});
    const [sec2, setSec2] = useState({});
    const [sec3, setSec3] = useState({});
    const [emailCopied, setEmailCopied] = useState(false);
    const [phoneCopied, setPhoneCopied] = useState(false);
    const [activeTab, setActiveTab] = useState("faq1");
    const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);

    const [selectedMember, setSelectedMember] = useState(null);

    // team data (you can later fetch this dynamically)

    const subjectOptions = [
        { value: "", label: "Subject" },
        { value: "general", label: "General Inquiry" },
        { value: "support", label: "Technical Support" },
        { value: "partnership", label: "Partnership" },
        { value: "media", label: "Media Inquiry" },
        { value: "aidubbing", label: "AI Dubbing" },
        { value: "ailicensing", label: "AI Licensing" },
    ];
    useEffect(() => {

        if (localStorage.getItem("token")) {

            clientActivity()
        }
        setContentSearchFlag(false)
        setRoute("notcontent")
    }, []);


    useEffect(() => {
        if (menus?.length > 0) {
            // Handle menuid 100003 → combine both team members
            const menuItem100003 = menus.find(item => item.menuid === 100003);
            if (menuItem100003?.team?.length >= 2) {
                const allMembers = [
                    ...menuItem100003.team[0].members,
                    ...menuItem100003.team[1].members,
                ];
                setTeamBoard(allMembers);
            }

            // Handle menuid 100002 → set sections
            const menuItem100002 = menus.find(item => item.menuid === 100002);
            if (menuItem100002?.team?.length >= 3) {
                setSec1(menuItem100002.team[0]);
                setSec2(menuItem100002.team[1]);
                setSec3(menuItem100002.team[2]);
            }
        }
    }, [menus]);

    const clientActivity = () => {
        let path = window.location.pathname.split("/");
        var presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": 'CONTACT US',
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        let urlLink;
        if (localStorage.getItem("previousid")) {
            urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
        } else {
            urlLink = lambda + '/activity?appname=' + appname
        }

        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response.data.statusCode === 200) {
                    localStorage.setItem("previousid", response.data.result)
                }
            });
    }

    const validateEmail = (e) => {

        setEmail(e.target.value);

    }

    function formvalidation() {

        let flag = true;
        if (localStorage.getItem("clientid")) {
            if (msg === "") {
                setErrmsg("Please enter Message");
                setTimeout(function () { setErrmsg("") }, 3000);
                flag = false;

                return;
            }
        } else {
            const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
            if (regEx.test(email)) {
                setEmailError("");
                setTimeout(function () { setEmailError("") }, 2000)
            } else if (!regEx.test(email) && email !== "") {
                setEmailError("Email is Not Valid");
                flag = false;

            }

            if (name == "") {
                setNameError("Please Enter Name");
                flag = false;

                return;
            }

            if (email == "") {
                setEmailError("Please Enter Email");
                flag = false;

                return;
            }
            if (subject == "") {
                setSubError("Please Enter Subject");
                flag = false;

                return;
            }
            if (msg === "") {
                setErrmsg("Please Enter Message");
                flag = false;

                return;
            }
        }

        if (flag) {
            if (activeCheckId == "") {
                handleContactus();
            }
        } else {
            setActiveCheckId("")
        }

        return;
    }
    const AddNotify = () => toast.success('Your message has been sent. Thank you!', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)
    const ShowError = () => toast.error('Sorry something Went Wrong, Please try again.', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)
    const handleContactus = async () => {
        try {
            setActiveCheckId("isload")
            if (clientData && clientData.name) {
                const response = await tmdbApi.ClientContactus({
                    "name": clientData && clientData.name ? clientData.name : name,
                    "emailid": clientData && clientData.personalemail ? clientData.personalemail : email,
                    "subject": subject,
                    "message": msg
                });
                console.log(response);
                if (response.statusCode == 200) {
                    if (response.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response.result == "Client inactived") {
                        setInactiveFlag(true)

                    } else {
                        AddNotify()
                        setActiveCheckId("")
                        setName("");
                        setEmail("");
                        setSubject("");
                        setMsg("");
                        setTimeout(function () {
                            setSuccess("");
                        }, 3000);
                    }
                }
            } else {
                const response = await tmdbApi.contactus({
                    "name": name,
                    "emailid": email,
                    "subject": subject,
                    "message": msg
                });
                console.log(response);
                if (response.statusCode == 200) {
                    setActiveCheckId("")
                    AddNotify()
                    setName("");
                    setEmail("");
                    setSubject("");
                    setMsg("");
                    setTimeout(function () {
                        setSuccess("");
                    }, 3000);
                }
            }

        } catch {
            ShowError()

            setActiveCheckId("")
            console.log("error");
        }
    };


    const handleSubmit = (e) => {
        formvalidation();
    }
    const handleName = (e) => {
        setNameError("");
    }

    const handleEmail = (e) => {
        setEmailError("");
    }

    const handleSubject = (e) => {
        setSubError("");
    }

    const handleMessage = (e) => {
        setErrmsg("");
    }

    let img = window.app.img;
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);



    if (config.common && config.common.imagesCDN) {
        img = config.common.imagesCDN;
    }


    function getPlainText(html) {
        if (!html) return "";
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }
    // Utility function to shorten text safely
    function getShortText(text, maxLength) {
        if (!text) return ""; // return empty string if undefined/null
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + "...";
    }


    const handleDescription = (e, item) => {
        setShowDescription(!showDescription)
    }
    const handleClick = (value) => {
        setShowDescription(!showDescription)
        setSelectedMember(value)
    }
    const customStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: "#111111",
            borderColor: "#2c2c2c",
            boxShadow: "none",
            "&:hover": { borderColor: "#2c2c2c" },
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#292929", // menu background
        }),

        menuList: (provided) => ({
            ...provided,
            backgroundColor: "#292929", // list background
        }),
        menu: (provided) => ({
            ...provided,
            // keep default scroll and dropdown behavior
        }),
        // no need to override indicators or other components
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "rgb(104, 104, 104)",           // change indicator (arrow) color
            "&:hover": { color: "rgb(104, 104, 104)" },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#020202 !important", // keep chip dark
            border: "1px solid #444444",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#ffffff",
            backgroundColor: "#020202",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#ffffff",
            fontSize: "12px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#ffffff",
            backgroundColor: "#020202",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "#020202",
                color: "#ffffff",
            },
        }),
    };
    const handleChange = (selectedOption) => {
        setSubject(selectedOption?.value || ""); // store value directly in state
    };
    const handleCopy = (text, type) => {
        navigator.clipboard.writeText(text);

        if (type === "email") {
            setEmailCopied(true);
            setTimeout(() => setEmailCopied(false), 1000);
        } else {
            setPhoneCopied(true);
            setTimeout(() => setPhoneCopied(false), 1000);
        }
    };
    return (
        <>
            {localStorage.getItem("token") ? <InsideHeader activeClass={"4"} /> : <LandingHeader />}
            <Modal
                show={showDescription}
                onHide={() => setShowDescription(false)}
                className="modal title-des-popup"
                id="descriptionPopup"
            >
                <Modal.Header>
                    <Modal.Title>About</Modal.Title>
                    {/* Close button */}
                    <button
                        type="button"
                        className="close-btn"
                        style={{ cursor: "pointer", border: "none", background: "transparent" }}
                        onClick={() => setShowDescription(false)}
                    >
                        <span className="material-icons">close</span>
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <p style={{ whiteSpace: "pre-line" }}>{ReactHtmlParser(selectedMember?.descriptioncontent ?? selectedMember?.about)}</p>

                </Modal.Body>
            </Modal>
            <section className="faq-section">
                <div className="container-fluid faq-container">
                    <div className="faq-header">
                        <h2>Frequently Asked Questions</h2>
                    </div>

                    <div className="faq-wrapper">
                        <div className="faq-stepper" id="myScrollspy">
                            <ul className="nav nav-pills nav-stacked">
                                <li className={activeTab === "faq1" ? "active" : ""}>
                                    <a onClick={() => setActiveTab("faq1")} href="#faqAccordion-1">General FAQ's</a>
                                </li>

                                <li className={activeTab === "faq2" ? "active" : ""}>
                                    <a onClick={() => setActiveTab("faq2")} href="#faqAccordion-2">Marketplace FAQ's</a>
                                </li>

                                <li className={activeTab === "faq3" ? "active" : ""}>
                                    <a onClick={() => setActiveTab("faq3")} href="#faqAccordion-3">Production Circle FAQ's</a>
                                </li>

                                <li className={activeTab === "faq4" ? "active" : ""}>
                                    <a onClick={() => setActiveTab("faq4")} href="#faqAccordion-4">AI Licensing FAQ's</a>
                                </li>

                                <li className={activeTab === "faq5" ? "active" : ""}>
                                    <a onClick={() => setActiveTab("faq5")} href="#faqAccordion-5">AI Dubbing / Subtitling FAQ's</a>
                                </li>
                            </ul>
                        </div>

                        <div className="faq-content">
                            {/* General FAQ's */}
                            <div className="faq-list" id="faqAccordion-1">
                                <p className="faq-title">General</p>
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#general-1"
                                    >
                                        <h4>How do I login?</h4>
                                        <span className="material-icons faq-icon">expand_less</span>
                                    </div>

                                    <div
                                        id="general-1"
                                        className="collapse"
                                        data-bs-parent="#faqAccordion-1"
                                    >
                                        <div className="faq-answer">
                                            <p>
                                                To log in, first select whether you are a buyer, seller, or both. Then enter your personal details to create
                                                your account. Once completed, you will receive an email asking you to verify your email address and
                                                agree to the Terms Conditions. After verification, you may log in using your email and password.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#general-2"
                                    >
                                        <h4>Where is Orasi headquartered?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="general-2" className="collapse" data-bs-parent="#faqAccordion-1">
                                        <div className="faq-answer">
                                            <p>Orasi is headquartered in Jersey City, New Jersey, USA.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#general-3"
                                    >
                                        <h4>In which countries do Orasi have a presence?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="general-3" className="collapse" data-bs-parent="#faqAccordion-1">
                                        <div className="faq-answer">
                                            <p>We have local representatives across Asia, Southeast Asia, MENA, CIS, Europe, Latin America (LATAM), and North America (NA).</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#general-4"
                                    >
                                        <h4>I’m having trouble logging in, what should I do?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="general-4" className="collapse" data-bs-parent="#faqAccordion-1">
                                        <div className="faq-answer">
                                            <p>Please follow the login steps mentioned above. If the issue persists, feel free to contact us (info@orasimedia.com) and our team will assist you promptly.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#general-5"
                                    >
                                        <h4>Who can I reach out to for any queries?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="general-5" className="collapse" data-bs-parent="#faqAccordion-1">
                                        <div className="faq-answer">
                                            <p>Visit our Contact Us page and submit the form with your query. A member of our team will get back to you shortly.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Marketplace */}
                            <div className="faq-list" id="faqAccordion-2">
                                <p className="faq-title">Marketplace</p>
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-1"
                                    >
                                        <h4>How to search on the marketplace?</h4>
                                        <span className="material-icons faq-icon">expand_less</span>
                                    </div>

                                    <div
                                        id="marketplace-1"
                                        className="collapse"
                                        data-bs-parent="#faqAccordion-2"
                                    >
                                        <div className="faq-answer">
                                            <p>You can search in two ways:</p>
                                            <ul>
                                                <li>Basic Search: Use the search bar at the top to look for titles by name.</li>
                                                <li>Advanced Search (recommended): Filter by Category, Title, Genre, Language, Available Territories, Rights Type, Video Format, and Release Year to refine your results.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-2"
                                    >
                                        <h4>How do I make an inquiry about a title?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="marketplace-2" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>If you&#39;re interested in a title, add it to your Cart and click Enquire. A form will appear requesting additional details. Once submitted, our team will respond via email or call shortly.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-3"
                                    >
                                        <h4>How do I save or shortlist titles I like?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="marketplace-3" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>You can save titles for later or prepare to enquire by clicking the Cart icon to add them to your Cart.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-4"
                                    >
                                        <h4>Who are the buyers and sellers?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-4" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Our client base includes broadcasters, streaming platforms, channel networks, studios, production houses, individual producers, and distributors from around the world.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-5"
                                    >
                                        <h4>Can I directly buy content or contact a buyer/seller?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-5" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Direct transactions are not available on the platform. To purchase content, please submit an enquiry, and our team will assist you with next steps.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-6"
                                    >
                                        <h4>I am unable to view trailers or access title details, what should I do?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-6" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>If trailers or metadata are unavailable or not loading, please contact us through the Contact Us page and we’ll ensure the required details are provided.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-7"
                                    >
                                        <h4>What if I don’t find the title I am looking for?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-7" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>If the content you’re seeking isn’t listed, please submit a request via the Contact Us page. Our team will
                                                check it’s availability and get back to you. You can also use Preference feature by setting the
                                                preferences of type of titles that you would be interested in. Our team will reach out to you with titles,
                                                moreover, any new title added that matches your preference. You will get an email with the link to the
                                                matching titles as soon as they are added.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 8 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-8"
                                    >
                                        <h4>What happens after I submit an enquiry?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-8" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>A regional representative will reach out to you via email or call as soon as possible to gather any
                                                additional details.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 9 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-9"
                                    >
                                        <h4>What if I don’t get a response to my enquiry?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-9" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Please reach out to us via the Contact Us page or at info@orasimedia.com and we will get back to you within 24 hours.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 10 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-10"
                                    >
                                        <h4>How will the content be delivered?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-10" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Once deal terms are finalized, content is typically delivered via Google Drive, AWS S3, FTP, or another
                                                secure file transfer method.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 11 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-11"
                                    >
                                        <h4>Why haven’t I received any enquiries for my listed content? (seller may ask)</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-11" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>There may be several reasons, including:</p>
                                            <ul>
                                                <li>Low current demand</li>
                                                <li>Limited territorial availability</li>
                                                <li>Incomplete or insufficient metadata</li>
                                            </ul>
                                            <p>Our team can assist you with optimizing your listing.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 12 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-12"
                                    >
                                        <h4>How do I delist my content? (seller)</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-12" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Please reach out to <a href="#" className="anchor">info@orasimedia.com</a> and we will process your request.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* FAQ 13 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#marketplace-13"
                                    >
                                        <h4>If I have signed up as a seller / buyer and want to change, what should I do?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="marketplace-13" className="collapse" data-bs-parent="#faqAccordion-2">
                                        <div className="faq-answer">
                                            <p>Please reach out to us at <a href="#" className="anchor">info@orasimedia.com</a> and we will make the desired changes to your account.</p>
                                              
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Production Circle */}
                            <div className="faq-list" id="faqAccordion-3">
                                <p className="faq-title">Production Circle</p>
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-1"
                                    >
                                        <h4>What is The Production Circle?</h4>
                                        <span className="material-icons faq-icon">expand_less</span>
                                    </div>

                                    <div
                                        id="productioncircle-1"
                                        className="collapse"
                                        data-bs-parent="#faqAccordion-3"
                                    >
                                        <div className="faq-answer">
                                            <p>The Production Circle is an all-in-one collaboration platform for producers, directors, writers, and other
                                                stakeholders to manage every phase of production. Features include scriptwriting, storyboarding,
                                                character development, budgeting, scheduling, scene planning, and more—powered by AI-assisted
                                                tools, which can be turned on/off as per your discretion.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-2"
                                    >
                                        <h4>How do I sign up?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="productioncircle-2" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>Enter your email to create a free account. You will receive a verification email to confirm your address
                                                and set a password. After completing these steps, you can access The Production Circle
                                                dashboard.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-3"
                                    >
                                        <h4>How does it work?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="productioncircle-3" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>Once logged in, your dashboard provides access to tools such as scriptwriting, team collaboration, task
                                                management, moodboards, storyboards, budgeting, casting, production assistance, and more.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-4"
                                    >
                                        <h4>Can I add collaborators?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="productioncircle-4" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>Yes. You can invite team members to collaborate on projects and share documents, files, media, and
                                                tasks with them.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-5"
                                    >
                                        <h4>Who is The Production Circle for?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="productioncircle-5" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>It is designed for anyone involved in content creation—including producers, directors, writers,
                                                production executives, and other project stakeholders.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-6"
                                    >
                                        <h4>Can I write scripts using the platform?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="productioncircle-6" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>Yes absolutely. Our AI-powered tools allow you to write scripts, create scenes, build storyboards, and
                                                develop characters seamlessly.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#productioncircle-7"
                                    >
                                        <h4>What all can I do with the platform?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="productioncircle-7" className="collapse" data-bs-parent="#faqAccordion-3">
                                        <div className="faq-answer">
                                            <p>Visit the Get Help section for an overview of all features, including access to live chat, support
                                                resources, and feedback options.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* AI Licensing */}
                            <div className="faq-list" id="faqAccordion-4">
                                <p className="faq-title">AI Licensing</p>
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-1"
                                    >
                                        <h4>How does AI licensing work?</h4>
                                        <span className="material-icons faq-icon">expand_less</span>
                                    </div>

                                    <div
                                        id="ailicensing-1"
                                        className="collapse"
                                        data-bs-parent="#faqAccordion-4"
                                    >
                                        <div className="faq-answer">
                                            <p>Technology companies use video content to train machine learning models. Only data features are
                                                extracted—no human views the content. Models are trained for purposes such as speech-to-text,
                                                language translation, facial mapping, behavior modeling, etc.</p>
                                            <p>Your content will NOT be used for copying/replicating IP, cloning characters or voices, commercial
                                                resale, or any human consumption.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-2"
                                    >
                                        <h4>Where does my content go?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="ailicensing-2" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>Content can be submitted via Google Drive, AWS S3, or FTP. Once received, Orasi forwards it directly
                                                to the AI company for automated data extraction.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-3"
                                    >
                                        <h4>Is my IP protected?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="ailicensing-3" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>Yes, absolutely. Our contract explicitly states that your IP will not be copied, cloned, reproduced,
                                                commercially reused, or human-viewed.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-4"
                                    >
                                        <h4>Can actors or voices be cloned?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="ailicensing-4" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>No. Cloning of characters or voices is strictly prohibited.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-5"
                                    >
                                        <h4>What is the purpose of the licensing process?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="ailicensing-5" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>The content helps train machine learning models that improve various AI capabilities.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-6"
                                    >
                                        <h4>What content is eligible?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="ailicensing-6" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>We accept all HD-quality content, irrespective of genre or format.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#ailicensing-7"
                                    >
                                        <h4>How long does the entire process take?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="ailicensing-7" className="collapse" data-bs-parent="#faqAccordion-4">
                                        <div className="faq-answer">
                                            <p>After submission, Orasi reviews the content and forwards it to the AI company. The AI company
                                                typically requires 45–60 days to evaluate and approve eligible hours. Once approved, Orasi invoices
                                                the company. The full monetization cycle takes approximately 90–10 days from submission.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* AI Dubbing / Subtitling */}
                            <div className="faq-list" id="faqAccordion-5">
                                <p className="faq-title">AI Dubbing / Subtitling</p>
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-1"
                                    >
                                        <h4>How does subbing / dubbing process work?</h4>
                                        <span className="material-icons faq-icon">expand_less</span>
                                    </div>

                                    <div
                                        id="aidub-1"
                                        className="collapse"
                                        data-bs-parent="#faqAccordion-5"
                                    >
                                        <div className="faq-answer">
                                            <p>For VOD content, submit the video file along with your target languages. Delivery typically occurs
                                                within a week depending on volume.</p>
                                            <p>For samples, send up to 5 minutes of footage to <a>info@orasimedia.com</a>.</p>
                                            <p>For live dubbing, send your SRT link and we will set up a 2-hour proof of concept (POC). We will return
                                                a live dubbed SRT with less than 5 seconds of delay.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-2"
                                    >
                                        <h4>What are the costs?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="aidub-2" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <p>Approximate pricing:</p>
                                            <ul>
                                                <li>Subbing: $0.50–$3 per minute</li>
                                                <li>Dubbing (VOD): $2–$9 per minute</li>
                                                <li>Live dubbing: $0.25–$3 per minute</li>
                                            </ul>
                                            <p>Actual pricing varies based on language and volume.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-3"
                                    >
                                        <h4>What is the accuracy?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>

                                    <div id="aidub-3" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <p>Accuracy varies by language pair</p>
                                            <ul>
                                                <li>Common languages (Spanish, French, English, German, Arabic, Portuguese, etc): 95–98%</li>
                                                <li>Other languages: 85–98%</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-4"
                                    >
                                        <h4>What languages do we support?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="aidub-4" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <p>We support subbing and dubbing in 50+ languages. Contact us for specific details.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-5"
                                    >
                                        <h4>What is live dubbing / subbing?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="aidub-5" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <p>Any 24/7 channel or live event can be dubbed or subbed into another language with under 5 seconds
                                                of delay.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-6"
                                    >
                                        <h4>Who should I contact for language or pricing details?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="aidub-6" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <p>Please use the Contact Us page for all queries related to languages, pricing, and services.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="faq-item">
                                    <div
                                        className="faq-question collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#aidub-7"
                                    >
                                        <h4>What is the turnaround time?</h4>
                                        <span className="material-icons faq-icon">chevron_right</span>
                                    </div>
                                    <div id="aidub-7" className="collapse" data-bs-parent="#faqAccordion-5">
                                        <div className="faq-answer">
                                            <ul>
                                                <li>VOD content: Usually up to one week</li>
                                                <li>Live content: Under 5 seconds of real-time delay</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
            <LandingFooter menus={menus} />
        </>
    );
};

export default Faq;
